import { Component } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection } from 'angularfire2/firestore';
import { AngularFireAuth } from 'angularfire2/auth';
import { ModalController } from 'ionic-angular';
import { SessionDetailPage } from './../../pages/session-detail/session-detail';
import moment from 'moment';

interface Sessions {
  creationDate: Date;
  description: string;
  files: any[];
  idAlumno: any;
  idCoach: any;
  sessionDate: Date;
  title: string;
  id: string;
}

@Component({
  selector: 'sessions',
  templateUrl: 'sessions.html'
})
export class SessionsComponent {

  sessionsCollection: AngularFirestoreCollection<Sessions>;
  sessions: Sessions[];

  constructor(af: AngularFirestore, afa: AngularFireAuth, public modalCtrl: ModalController) {
    afa.auth.onAuthStateChanged(auth => {
      if (auth && auth.uid) {
        this.sessionsCollection = af.collection("Sessions", ref => ref.where("idAlumno", "==", auth.uid).orderBy("sessionDate","desc"));
        this.sessionsCollection.snapshotChanges().subscribe(snapshotChanges => {
          this.sessions = snapshotChanges.map(item => {
            const id = item.payload.doc.id;
            const data = item.payload.doc.data() as Sessions;
            return { id, ...data }
          });
        });
      }
    });
  }

  viewItem(item: any) {
    let Modal = this.modalCtrl.create(SessionDetailPage, { "item": item });
    Modal.present();
  }
  
  stringDate(date: any): string {
    moment.locale("es");
    return moment(date).format("lll");
  }

}



// WEBPACK FOOTER //
// ./src/components/sessions/sessions.ts